// JSON data for services - This should be moved to a separate file or fetched from API


const servicesData = [
    {
      id: 1,
      slug: "automation-logistics",
      title: "Logistics Automation",
      subtitle: "Moving to the cloud doesn't have to be complicated",
      description: "We transform last-mile logistics by integrating automation, ERP systems, and real-time analytics to ensure every package is delivered with speed and accuracy.",
      detailedDescription: "Moving to the cloud doesn't have to be complicated. We design and execute robust migration strategies, covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment.",
      link: "/service/automation-logistics",
      imagePosition: "left", // left or right
      image: "/assets/images/services/Automation Logistics.webp",
      projectRequirement: {
        title: "Last Mile made seamless",
        challenge: {
          title: "The Challenge",
          description: "Logistics teams struggled with manual dispatch, scattered order tracking, and limited insight into deliveries."
        },
        solution: {
          title: "Our Solution",
          description: "Configured and implemented a last-mile delivery system integrated with ERP, automated task dispatch using microservices, synchronized databases, and built a data lake for centralized insights."
        },
        impact: {
          title: "Impact",
          description: "Orders and delivery statuses are now tracked in real time, manual errors are minimized, and actionable insights drive smarter logistics decisions."
        }
      },
      features: {
        content: {
          title: "Capabilities That Power Digital Transformation",
          description: "We deliver comprehensive logistics solutions that streamline operations, enhance visibility, and drive data-driven decision-making for optimal delivery performance."
        },
        features: [
          {
            id: 1,
            title: "ERP-Integrated Last Mile Systems",
            description: "Automated task dispatch and seamless operations."
          },
          {
            id: 2,
            title: "Microservices Architecture",
            description: "Faster task assignment for improved efficiency."
          },
          {
            id: 3,
            title: "Data Lakes for Analytics",
            description: "Centralized data management bringing insights for route optimization and other strategic benefits."
          },
        ],
        images: {
          background: "/assets/images/Capabilities.svg",
          main: "/assets/images/services/Automation Logistics 1.webp",
        }
      }
    },
    {
      id: 2,
      slug: "cloud-migration",
      title: "Cloud Migration",
      subtitle: "Moving to the cloud doesn't have to be complicated",
      description: "Moving to the cloud doesn't have to be complicated. We design and execute robust migration strategies, covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment.",
      detailedDescription: "Moving to the cloud doesn't have to be complicated. We design and execute robust migration strategies, covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment.",
      link: "/service/cloud-migration",
      imagePosition: "left", // left or right
      image: "/assets/images/services/Cloud Migration.webp",
      projectRequirement: {
        title: "From On-Premise to AWS Cloud",
        challenge: {
          title: "The Challenge",
          description: "A corporate conglomerate needed to migrate critical on-prem systems to the cloud quickly and with minimal downtime."
        },
        solution: {
          title: "Our Solution",
          description: "Designed a robust AWS migration strategy covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment."
        },
        impact: {
          title: "Impact",
          description: "Migration completed in 3 months with minimal downtime, ensuring seamless transition and post-migration validation for long-term stability."
        }
      },
      features: {
        content: {
          title: "Capabilities That Power Cloud Migration",
          description: "We handle the entire migration process smoothly, ensuring minimal downtime and stable systems while keeping your business running."
        },
        features: [
          {
            id: 1,
            title: "End-to-End Lifecycle Management",
            description: "From initial assessment to post-migration optimization."
          },
          {
            id: 2,
            title: "Continuous Replication",
            description: "Data synchronization until cutover completion."
          },
          {
            id: 3,
            title: "Planned Cutovers",
            description: "To avoid business disruption."
          },
          {
            id: 4,
            title: "Long-Term Stability Assurance",
            description: "Assurance of long-term stability after migration."
          },
          {
            id: 5,
            title: "Minimal Downtime",
            description: "Proven processes that keep systems running."
          },
        ],
        images: {
          background: "/assets/images/Capabilities.svg",
          main: "/assets/images/services/Cloud Migration 1.webp",
        }
      }
    },
    {
      id: 3,
      slug: "customer-onboarding",
      title: "Optimized Customer Onboarding",
      subtitle: "Streamline customer acquisition with intelligent automation and real-time validation.",
      description: "This service focuses on re-engineering and automating the customer onboarding journey using customized back-end solutions.",
      detailedDescription: "It drastically reduces onboarding time, enhances efficiency, and improves data accuracy through real-time document validation and inconsistency detection.",
      link: "/service/customer-onboarding",
      imagePosition: "left", // left or right
      image: "/assets/images/services/Optimized Customer Onboarding.webp",
      projectRequirement: {
        title: "Bridging the traditional and digital financial worlds",
        challenge: {
          title: "The Challenge",
          description: "A 52-year-old bank wanted to create a digital product bridging USD accounts and crypto wallets, enabling a new client base and revenue streams."
        },
        solution: {
          title: "Our Solution",
          description: " Leveraged Appian and automation to build over 100 business processes, including automated onboarding, crypto core integrations, invoice reconciliation, loan origination, vendor management, and AI-powered analytics. Microservices architecture ensures millisecond performance."
        },
        impact: {
          title: "Impact",
          description: "Thousands of clients onboarded, 9-figure revenue generated, onboarding reduced from days to under an hour, and real-time processing of up to 3,000 transactions. Staff roles were enhanced, not replaced, maximizing human + AI synergy."
        }
      },
      features: {
        content: {
          title: "Capabilities That Power Customer Onboarding",
          description: "We deliver comprehensive onboarding solutions that streamline customer acquisition, enhance data accuracy, and provide seamless experiences through intelligent automation."
        },
        features: [
          {
            id: 1,
            title: "Customized Back-End Solutions",
            description: "Tailored back-end solutions for onboarding."
          },
          {
            id: 2,
            title: "Automation and Real-Time Analytics",
            description: "Integration of automation and real-time analytics."
          },
          {
            id: 3,
            title: "Intelligent Document Validation",
            description: "Intelligent document validation and inconsistency detection."
          },
          {
            id: 4,
            title: "End-to-End Workflow Design",
            description: "End-to-end workflow design and orchestration with Appian."
          },
          {
            id: 5,
            title: "Multiple Integrations Support",
            description: "Support for multiple integrations."
          },
        ],
        images: {
          background: "/assets/images/Capabilities.svg",
          main:  "/assets/images/services/Optimized Customer Onboarding 1.webp",
        }
      }
    }
  ];

  export default servicesData;

